// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.batch-form-container {
    background-color: #ffffff;
  border: 2px solid rgb(220, 219, 224);
    border-radius: 8px;
    padding: 30px;
    max-width: 600px;
    margin: auto;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
}

.editbatchTag{
    color: rgb(0, 0, 0);
    font-family: 'Times New Roman', Times, 'Merriweather', 'Libre Baskerville', 'Playfair Display', serif;
}

.batch-form-text {
    color: orange;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
    font-size: 1.5rem;
}

.batch-form-row {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
}

.batch-form-input-data {
    flex: 1 1;
    margin: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
}

.batch-form-input-data label {
    color: #200000;
    font-weight: 500;
    margin-bottom: 18px;
    font-size: 1rem;
}

.batch-form-input-data input,
.batch-form-input-data select {
    padding: 8px;
    border: 1px solid #8d8a8a;
    border-radius: 4px;
    transition: border-color 0.3s;
    font-size: 0.9rem;
}

.batch-form-input-data input:focus,
.batch-form-input-data select:focus {
    border-color: rgb(44, 190, 0);
    background-color: rgb(255, 255, 255);
    outline: none;
    box-shadow: 0 0 5px rgba(255, 165, 0, 0.3);
}

.input-error {
    border-color: red !important;
}

.error {
    color: red;
    font-size: 0.8rem;
    margin-top: 5px;
}

.batch-form-submit-btn {
    text-align: center;
    margin-top: 20px;
}

.batch-form-submit-btn .MuiButton-root {
    background-color: transparent;
    color: rgb(0, 0, 0);
}

.batch-form-submit-btn .MuiButton-root:hover {
    background-color: #076b25;
}
`, "",{"version":3,"sources":["webpack://./src/Components/StaffEditPage/StaffEdit.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;EAC3B,oCAAoC;IAClC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,qGAAqG;AACzG;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;;IAEI,6BAA6B;IAC7B,oCAAoC;IACpC,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".batch-form-container {\r\n    background-color: #ffffff;\r\n  border: 2px solid rgb(220, 219, 224);\r\n    border-radius: 8px;\r\n    padding: 30px;\r\n    max-width: 600px;\r\n    margin: auto;\r\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.editbatchTag{\r\n    color: rgb(0, 0, 0);\r\n    font-family: 'Times New Roman', Times, 'Merriweather', 'Libre Baskerville', 'Playfair Display', serif;\r\n}\r\n\r\n.batch-form-text {\r\n    color: orange;\r\n    font-weight: bold;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.batch-form-row {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.batch-form-input-data {\r\n    flex: 1;\r\n    margin: 10px;\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.batch-form-input-data label {\r\n    color: #200000;\r\n    font-weight: 500;\r\n    margin-bottom: 18px;\r\n    font-size: 1rem;\r\n}\r\n\r\n.batch-form-input-data input,\r\n.batch-form-input-data select {\r\n    padding: 8px;\r\n    border: 1px solid #8d8a8a;\r\n    border-radius: 4px;\r\n    transition: border-color 0.3s;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.batch-form-input-data input:focus,\r\n.batch-form-input-data select:focus {\r\n    border-color: rgb(44, 190, 0);\r\n    background-color: rgb(255, 255, 255);\r\n    outline: none;\r\n    box-shadow: 0 0 5px rgba(255, 165, 0, 0.3);\r\n}\r\n\r\n.input-error {\r\n    border-color: red !important;\r\n}\r\n\r\n.error {\r\n    color: red;\r\n    font-size: 0.8rem;\r\n    margin-top: 5px;\r\n}\r\n\r\n.batch-form-submit-btn {\r\n    text-align: center;\r\n    margin-top: 20px;\r\n}\r\n\r\n.batch-form-submit-btn .MuiButton-root {\r\n    background-color: transparent;\r\n    color: rgb(0, 0, 0);\r\n}\r\n\r\n.batch-form-submit-btn .MuiButton-root:hover {\r\n    background-color: #076b25;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
